import React from "react";

//import { Button } from '@material-ui/core'
import { FormContext, RepeatableContext } from "./context";
import {
  DateField,
  ImageField,
  AddressField,
  SwitchField,
  ButtonField,
  CheckField,
  SelectField,
  MultiSelectField,
} from "./Fields";

class Repeatable extends React.Component {
  getRepeatableProps(Component, context) {
    const data = context.formdata[this.props.datakey];

    const valid = (v) => {
      if (typeof Component.props.valid === "function") {
        return Component.props.valid(v);
      } else if (Component.props.valid && Component.props.valid.valid) {
        return Component.props.valid.valid(v)
          ? true
          : Component.props.valid.message;
      }
      return true;
    };

    const update = (field, value, cb) => {
      context.changeData(
        {
          [this.props.datakey]: data.map((v, i) => {
            return i === this.props.index ? { ...v, [field]: value } : v;
          }),
        },
        cb
      );
    };

    const value = Component.props.value
      ? Component.props.value
      : data[this.props.index] && data[this.props.index][Component.props.id]
      ? data[this.props.index][Component.props.id]
      : "";

    return {
      ...Component.props,
      value: value,
      onChange: (e) => {
        if (Component instanceof DateField)
          update(Component.props.id, e ? e._d : null);
        else if (Component instanceof ImageField) update(Component.props.id, e);
        else if (Component instanceof AddressField)
          update(Component.props.id, e.target ? e.target.value : e);
        else if (Component instanceof SwitchField)
          update(Component.props.id, e.target.checked);
        else if (Component instanceof CheckField)
          update(Component.props.id, e.target.checked);
        else if (Component instanceof SelectField)
          update(Component.props.id, e);
        else if (Component instanceof MultiSelectField)
          update(Component.props.id, e);
        else update(Component.props.id, e.target.value);
      },
      onClick: (e) => {
        if (Component instanceof ButtonField)
          update(Component.props.id, Component.props.value, () =>
            Component.props.onClick ? Component.props.onClick() : context.next()
          );
        else if (Component.props.onClick) Component.props.onClick();
      },
      valid: (data) => {
        if (!data) return true;
        const v = data[Component.props.id];

        if (Component.props.required && !v) return "Is a required field";
        if (Component.props.required || v) return valid(v);
        return true;
      },
    };
  }

  render() {
    return (
      <FormContext.Consumer>
        {(context) => (
          <RepeatableContext.Provider
            value={{
              type: this.props.type,
              onDelete: this.props.onDelete,
              data: context.formdata[this.props.datakey],
              key: this.props.datakey,
              index: this.props.index,
              //						abandon: <Button key="abandon" onClick={ () => this.props.onDelete(this.props.index) }>Remove { this.props.type }</Button>,
              getRepeatableProps: (component) =>
                this.getRepeatableProps(component, context),
            }}
          >
            {this.props.children}
          </RepeatableContext.Provider>
        )}
      </FormContext.Consumer>
    );
  }
}

export default Repeatable;
